import moment from "moment-timezone";
import { ModalService } from "../../services/modal/modal.service";

export const cropDict: { [key: string]: string } = {
  Alfalfa: "Alfalfa and Alfalfa Mixtures",
  "Almonds - with cover crop": "Almonds",
  "Almonds - without cover crop": "Almonds",
  "Apples - with cover crop": "Apples",
  "Apples - without cover crop": "Apples",
  "Apricots - with cover crop": "Apricots",
  "Apricots - without cover crop": "Apricots",
  "Beans (dry)": "Beans (Dry)",
  "Garbanzo Beans": "Beans (Dry)",
  Blueberries: "Bush Berries",
  Carrots: "Carrots",
  "Cherries - with cover crop": "Cherries",
  "Cherries - without cover crop": "Cherries",
  "Grapefruit - with cover crop": "Citrus",
  "Grapefruit - without cover crop": "Citrus",
  "Lemon - with cover crop": "Citrus",
  "Lemon - without cover crop": "Citrus",
  "Mandarin - with cover crop": "Citrus",
  "Mandarin - without cover crop": "Citrus",
  "Orange (navel) - with cover crop": "Citrus",
  "Orange (navel) - without cover crop": "Citrus",
  "Orange (valencia) - with cover crop": "Citrus",
  "Orange (valencia) - without cover crop": "Citrus",
  "Other Citrus - with cover crop": "Citrus",
  "Other Citrus - without cover crop": "Citrus",
  "Tangerines - with cover crop": "Citrus",
  "Tangerines - without cover crop": "Citrus",
  "Cole Crops (Broccoli/Cauliflower)": "Cole Crops",
  "Corn (field)": "Corn, Sorghum and Sudan",
  "Corn (sweet)": "Corn, Sorghum and Sudan",
  Sorghum: "Corn, Sorghum and Sudan",
  Sudangrass: "Corn, Sorghum and Sudan",
  Cotton: "Cotton",
  "Grapes (raisin) - with cover crop": "Grapes",
  "Grapes (raisin) - without cover crop": "Grapes",
  "Grapes (table) - with cover crop": "Grapes",
  "Grapes (table) - without cover crop": "Grapes",
  "Grapes (wine) - with cover crop": "Grapes",
  "Grapes (wine) - without cover crop": "Grapes",
  "Kiwi - with cover crop": "Kiwi",
  "Kiwi - without cover crop": "Kiwi",
  Lettuce: "Lettuce/Leafy Greens",
  Cantaloupe: "Melons, Squash and Cucumbers",
  Cucumbers: "Melons, Squash and Cucumbers",
  "Honeydew melons": "Melons, Squash and Cucumbers",
  Pumpkins: "Melons, Squash and Cucumbers",
  Squash: "Melons, Squash and Cucumbers",
  Watermelon: "Melons, Squash and Cucumbers",
  "Figs - with cover crop": "Miscellaneous Deciduous",
  "Figs - without cover crop": "Miscellaneous Deciduous",
  "Miscellaneous Deciduous - with cover crop": "Miscellaneous Deciduous",
  "Miscellaneous Deciduous - without cover crop": "Miscellaneous Deciduous",
  "Persimmons - with cover crop": "Miscellaneous Deciduous",
  "Persimmons - without cover crop": "Miscellaneous Deciduous",
  Hemp: "Miscellaneous Field Crops",
  Barley: "Miscellaneous Grain and Hay",
  "Cover Crop": "Miscellaneous Grain and Hay",
  "Forage Mix": "Miscellaneous Grain and Hay",
  "Other Small Grains": "Miscellaneous Grain and Hay",
  Teff: "Miscellaneous Grain and Hay",
  Triticale: "Miscellaneous Grain and Hay",
  Ryegrass: "Miscellaneous Grasses",
  "Miscellaneous Subtropical - with cover crop":
    "Miscellaneous Subtropical Fruits",
  "Miscellaneous Subtropical - without cover crop":
    "Miscellaneous Subtropical Fruits",
  "Miscellaneous Truck Crops": "Miscellaneous Truck Crops",
  Pasture: "Mixed Pasture",
  "Olives - with cover crop": "Olives",
  "Olives - without cover crop": "Olives",
  Garlic: "Onions and Garlic",
  Onions: "Onions and Garlic",
  "Nectarines - with cover crop": "Peaches/Nectarines",
  "Nectarines - without cover crop": "Peaches/Nectarines",
  "Peaches - with cover crop": "Peaches/Nectarines",
  "Peaches - without cover crop": "Peaches/Nectarines",
  "Pears - with cover crop": "Pears",
  "Pears - without cover crop": "Pears",
  "Pecans - with cover crop": "Pecans",
  "Pecans - without cover crop": "Pecans",
  Peppers: "Peppers",
  "Pistachios - with cover crop": "Pistachios",
  "Pistachios - without cover crop": "Pistachios",
  "Plums - with cover crop": "Plums",
  "Plums - without cover crop": "Plums",
  "Pomegranates - with cover crop": "Pomegranates",
  "Pomegranates - without cover crop": "Pomegranates",
  Potatoes: "Potatoes",
  "Prunes - with cover crop": "Prunes",
  "Prunes - without cover crop": "Prunes",
  Rice: "Rice",
  Safflower: "Safflower",
  Strawberries: "Strawberries",
  Sunflower: "Sunflower",
  "Sweet Potatoes": "Sweet Potatoes",
  Tomatoes: "Tomatoes",
  Turf: "Turf",
  Fallow: "Unclassified Fallow",
  "Walnuts - with cover crop": "Walnuts",
  "Walnuts - without cover crop": "Walnuts",
  Wheat: "Wheat",
  "Sugar Beets": "Sugar Beets",
  Oats: "Miscellaneous Grain and Hay",
};

// Function to format numbers (ensure they are in decimal format)
export const formatNumber = (value: any, numDecimal: number = 5): string => {
  // Check if the value is a valid number and convert it to a decimal format
  if (value !== null && value !== undefined) {
    const num = parseFloat(value);
    // Only return formatted number if it's a valid number
    return !isNaN(num) ? num.toFixed(numDecimal) : "";
  }
  return "0"; // Return empty string if the value is not a number or invalid
};

/**
 * Convert all claimed fields timeseries data into one csv file, separate by FieldID
 * @description If seeing weird placement or non existing column. Might be due to weird acres column
 */
export const ET_INCH_FIELDS = new Set(["eta", "ceta", "prcp", "cprcp"]);

/**
 * Convert an ET/precipitation value from inches to the caller's display unit.
 * Returns inches unchanged when not in acre-feet mode or when acres is missing.
 */
export const convertInchesToDisplayUnit = (
  inches: number | null | undefined,
  acres: number | null | undefined,
  useAcreFeet: boolean,
): number | null => {
  if (inches == null) return null;
  if (!useAcreFeet || !acres) return inches;
  return (inches * acres) / 12;
};

export const convertAllETToCSV = async (
  claimedFields: any[] | undefined,
  CSVHeaderTitle: string[],
  csvHeader: string[],
  currentDate: any,
  displayUnit: boolean | "inches" | "acreFeet" | "feet" = "inches",
) => {
  if (!claimedFields) {
    console.error(`No claimed fields available to download.`);
    return "";
  }
  // Each field has a list of ET values objects that need to be flat map out also
  const csvPromises = claimedFields.map(async (field, i) => {
    if (i !== 0 && i % 10 === 0) await new Promise((res) => setTimeout(res, 0)); // Yield back to main thread for every 10 files/fields
    const rows = (field.userFieldEtvalues as any[]).flatMap((etVal) => {
      if (etVal["et_date"] > currentDate.format("YYYY-MM-DD")) {
        // Remove row with future dates
        return [];
      }
      const rowETVal = csvHeader.map((col) => {
        if (col === "acres") return field.acres; // acres is not in the etVal object
        if (col === "field_name") return field.field_name;
        if (col === "entities") {
          const list = Array.isArray(field.entities) ? field.entities : [];
          return list
            .map((e: { name: string; email: string }) => e.name)
            .join("; ");
        }
        // Only convert these fields to acre-feet. It won't be processed again
        if (ET_INCH_FIELDS.has(col) && typeof etVal[col] === "number") {
          const useAcreFeet =
            displayUnit === true || displayUnit === "acreFeet";
          if (useAcreFeet) {
            return formatNumber(
              convertInchesToDisplayUnit(etVal[col], field.acres, true),
            );
          }
          if (displayUnit === "feet") {
            return formatNumber(etVal[col] / 12);
          }
        }
        // Similar as downloading single field csv.
        if (col === "crop_type") {
          if (field.isperennialtree) {
            // Set up the crop_type_01 as the crop_type if it is perennial tree
            return field.crop_type_01;
          } else {
            // Else, compare the dates
            if (
              moment
                .utc(etVal["et_date"])
                .isBetween(
                  moment.utc(field.ls_start_01),
                  moment.utc(field.ls_end_01),
                  "day",
                  "[]",
                )
            ) {
              return field.crop_type_01;
            } else if (
              field.ls_start_02 &&
              moment
                .utc(etVal["et_date"])
                .isBetween(
                  moment.utc(field.ls_start_02),
                  moment.utc(field.ls_end_02),
                  "day",
                  "[]",
                )
            ) {
              return field.crop_type_02;
            } else if (
              field.ls_start_03 &&
              moment
                .utc(etVal["et_date"])
                .isBetween(
                  moment.utc(field.ls_start_03),
                  moment.utc(field.ls_end_03),
                  "day",
                  "[]",
                )
            ) {
              return field.crop_type_03;
            } else {
              return "Fallow";
            }
          }
        }

        return col !== "et_date" ? formatNumber(etVal[col]) : etVal["et_date"];
      });
      return [rowETVal.map(escapeCSV).join(",")];
    });
    return rows.join("\n");
  });
  const CSVFileList = await Promise.all(csvPromises);
  return [CSVHeaderTitle, ...CSVFileList].join("\n");
};

/**
 * Escape special characters in a value for CSV format
 * @param value Value to escape for CSV
 */
export const escapeCSV = (value: any) => {
  if (value === null || value === undefined) {
    return "";
  }
  const str = value.toString();
  if (/[",\n]/.test(str)) {
    // if string contains quote, comma or newline
    return `"${str.replace(/"/g, '""')}"`; // Double wrap in quotes so we can escape quotes by doubling them
  }
  return str;
};

export const NOOP = () => {};

/**
 * @param modalService ModalService instance to show dialog
 */
export const alertNoClaimedField = async (modalService: ModalService) => {
  return modalService.openDialogAsync({
    message: "No claimed fields in your account.",
    actions: [
      {
        label: "OK",
        action: () => "confirm",
      },
    ],
  });
};

// Role constants for easy reuse
export const ROLES = {
  GROWER: "grower",
  MANAGER: "manager",
  ENTITY: "entity",
  ADMIN: "admin",
} as const;

// Type derived from the constant values
export type Role = (typeof ROLES)[keyof typeof ROLES];
